import styled from 'styled-components';
import FlatList from 'flatlist-react';

export const Container = styled(FlatList)`
  display: flex;
  margin-top: 50px;
`;
